export const APP_ID = '2063261e3e1a85eb';
export const REGION = 'eu';
export const AUTH_KEY = 'b020362d76e4cb3b0e5b4f04e31547901ddb7b35';
export const WEB_APP_HOME = 'https://cometchat.pages.dev/';
export const WEB_APP_DYNAMIC_LINK = 'https://cometchat.page.link/?link=https://cometchat.pages.dev/__ID__&apn=com.reactnativecallingandroid';
export const WIDGET_ID = '70470a88-7f9e-4786-9dec-af41c3e6de11';
